import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpBaseService, SnackbarMsgService } from 'app/shared/services';

import { IClientApplication } from '../shared';
import { IClientApplicationForCreation, IClientApplicationForEdit } from './@shared';
import { environment } from 'environments/environment';
import { AuthService } from 'app/core/auth/auth.service';
import { IAuthData } from 'app/modules/auth';


@Injectable({
  providedIn: 'root'
})
export class ClientsApplicationsApiService extends HttpBaseService {
  private readonly _authService = inject(AuthService);

  constructor() {
    super(inject(HttpClient), inject(SnackbarMsgService));
  }

  getClientsApplications(params: any = null) {
    const queryParams = params ? new HttpParams({fromObject: params}) : new HttpParams();

    return this._http.get<IClientApplication[]>(environment.apiUrl + 'clients/access', { 
      params: queryParams, 
      observe: "response" 
    }).pipe(
      this._handleError(false),
      this._mapPagination()
    );
  }

  createClientApplication(relation: IClientApplicationForCreation) {
    return this._http.post<IClientApplication>(environment.apiUrl + 'clients/access', relation).pipe(
      this._handleError(),
    );
  }

  updateClientApplication(id: string, relation: IClientApplicationForEdit) {
    return this._http.put<IClientApplication>(environment.apiUrl + 'clients/access/' + id, relation).pipe(
      this._handleError(),
    );
  }

  deleteClientApplication(id: string) {
    return this._http.delete<void>(environment.apiUrl + 'clients/access/' + id).pipe(
      this._handleError(),
    );
  }

  loginAs(id: string) {
    return this._http.post<IAuthData>(environment.apiUrl + 'auth/auth-as/', {
      clientApplicationId: id,
      accessToken: this._authService.accessToken
    }).pipe(
      this._handleError(),
    );
  }
}